<template>

    <div>

        <input type="hidden" name="stay-on-page" v-model="stayOnPage">

        <div class="row">

            <div class="col-md-6">

                <div class="packages-list-heading mb-4">Pakiety dostępne do przypisania</div>

                <div class="packages-list-wrapper mb-4" v-if="availablePackages.length > 0">
                    <div class="package-element" v-for="package_ in availablePackagesSorted">
                        <img v-if="package_.area.icon_url !== null" :src="package_.area.icon_url" class="area-icon" :title="'Obszar: ' + package_.area.display_name">
                        <div v-if="package_.area.icon_url === null" class="area-icon-placeholder" :title="'Obszar: ' + package_.area.display_name">?</div>
                        <div class="package-name">
                            {{ package_.display_name }}
                        </div>
                        <div class="package-action">
                            <a href="#" @click="assign(package_)">Przypisz</a>
                        </div>
                    </div>
                </div>

                <div class="packages-list-empty mb-4" v-if="availablePackages.length === 0">Brak pakietów</div>

            </div>

            <div class="col-md-6">

                <div class="packages-list-heading mb-4">Przypisane pakiety</div>

                <div class="packages-list-wrapper" v-if="assignedPackages.length > 0">
                    <div class="package-element" v-for="package_ in assignedPackagesSorted">
                        <img v-if="package_.area.icon_url !== null" :src="package_.area.icon_url" class="area-icon" :title="'Obszar: ' + package_.area.display_name">
                        <div v-if="package_.area.icon_url === null" class="area-icon-placeholder" :title="'Obszar: ' + package_.area.display_name">?</div>
                        <div class="package-name">
                            {{ package_.display_name }}
                        </div>
                        <div class="package-action">
                            <a href="#" @click="remove(package_)" class="text-danger">Usuń</a>
                        </div>
                    </div>
                </div>

                <div class="packages-list-empty" v-if="assignedPackages.length === 0">Brak pakietów</div>

            </div>

        </div>

    </div>

</template>

<script>

    export default {

        name: 'MachineTemplatePackages',

        props: [
            'machineTemplateInput',
            'allPackages',
            'assignedPackagesInput'
        ],

        data() {
            return {
                eventHub: window.eventHub,
                machineTemplate: null,
                availablePackages: [],
                assignedPackages: [],
                stayOnPage: false
            }
        },

        computed: {
            availablePackagesSorted: function () {
                return _.orderBy(this.availablePackages, 'order')
            },
            assignedPackagesSorted: function () {
                return _.orderBy(this.assignedPackages, 'order')
            }
        },

        beforeMount() {

            this.machineTemplate = this.machineTemplateInput;
            this.availablePackages = this.allPackages;
            this.assignedPackages = this.assignedPackagesInput;
            this.assignedPackages.forEach(package_ => {
                this.availablePackages.splice(this.availablePackages.findIndex(item => item.id === package_.id), 1);
            });

        },

        created () {
            this.eventHub.$on('submit-form', (stay) => {
                this.stayOnPage = stay;
                this.save();
            })
        },

        beforeDestroy () {
            this.eventHub.$off('submit-form')
        },

        methods: {

            assign(package_) {
                this.assignedPackages.push(package_);
                this.availablePackages.splice(this.availablePackages.findIndex(item => item.id === package_.id), 1);
                this.edited = true;
            },

            remove(package_) {
                this.assignedPackages.splice(this.assignedPackages.findIndex(item => item.id === package_.id), 1);
                delete  package_.pivot;
                this.availablePackages.push(package_);
                this.edited = true;
            },

            save() {
                axios.put(route('machine::machine-templates.update-packages', {id: this.machineTemplate.id}), {
                    assigned_packages: this.assignedPackages.map(package_ => package_.id)
                })
                    .then(response => {
                        if (this.stayOnPage) {
                            this.assignedPackages = response.data.data.assignedPackages;
                            this.eventHub.$emit('processing-finish');
                            this.eventHub.$emit('toast-notification', response.data.message, 'success');
                        } else {
                            window.location.href = route('machine::machine-templates.index') + '?status-message=success:' + response.data.message;
                        }
                    })
                    .catch(response => {
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', 'Coś poszło nie tak. Sprawdź poprawność danych.', 'error');
                    });
            }

        }
    }

</script>

<style scoped>

    .packages-list-heading {
        font-size: 1.25rem;
    }

    .packages-list-wrapper {
        border-top: 1.5px solid #e5e5e5;
    }

    .packages-list-wrapper > .package-element {
        display: flex;
        align-items: center;
        border: 1.5px solid #e5e5e5;
        border-top: none;
    }

    .packages-list-wrapper > .package-element > .area-icon {
        border-radius: 50%;
        width: 30px;
        margin-left: 10px;
    }

    .packages-list-wrapper > .package-element > .area-icon-placeholder {
        border: 1.5px solid #9b9b9b;
        border-radius: 50%;
        width: 30px;
        height: 30px;
        margin-left: 10px;
        align-items: center;
        text-align: center;
        font-size: 120%;
        color: #9b9b9b;
        font-weight: 600;
        line-height: 28px;
        cursor: default;
    }

    .packages-list-wrapper > .package-element > .package-name {
        display: inline-block;
        position: relative;
        padding: 10px;
        left: 0;
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .packages-list-wrapper > .package-element > .package-action {
        padding: 10px;
        margin-left: auto;
    }

    .packages-list-empty {
        border: 1.5px solid #e5e5e5;
        padding: 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-style: italic;
        text-align: center;
    }

</style>
